<template>
    <div>
        <!-- 筛选 -->
        <my-search timeScreen :inputArr="inputArr" :searchParams="searchParams" :order="2" buttonScreen @searchEvent="searchEvent" @addEvent="addEvent" @allDel="allDel" @allExport="allExport" @allImportTemplate="allImportTemplate" />

        <!-- 表格 + 卡片 -->
        <el-row :gutter="15">
            <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="17">
                <!-- 列表 -->
                <my-table :loading="loading" :tableData="tableData" :tableHeader="tableHeader" :pageParams="pageParams" @click.native="testNative" @handleSelectionChange="handleSelectionChange" @handleCurrentChange="handleCurrentChange" />
                <!-- 分页组件 -->
                <my-pagination :childMsg="pageParams" @callFather="callFather" />
            </el-col>
            <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="7">
                <el-card class="box-card" shadow="never">
                    <div slot="header" class="clearfix">
                        <el-tooltip class="item" effect="dark" content="选择指定用户分配角色" placement="top">
                            <span class="role-span">角色分配</span>
                        </el-tooltip>
                        <el-button icon="el-icon-check" size="mini" style="float: right; padding: 6px 9px" type="primary" :disabled="!showButton" @click="saveRole">保存</el-button>
                    </div>
                    <el-checkbox-group v-model="checkRoleArr" size="small">
                        <el-checkbox style="width: 70px; padding: 10px 0" v-for="(item, index) in roleList" :label="item.id" :key="index" :checked="item.createTime">{{ item.roleName }}</el-checkbox>
                    </el-checkbox-group>
                </el-card>
            </el-col>
        </el-row>

        <!-- 添加、修改组件 :selectArrAdd="selectArr" -->
        <my-dialog :isDialogShow.sync="isDialogShow" :operTitle="operTitle" :operForm="operForm" :operFormArr="operFormArr" :rules="rules" :loading="loading" @submitForm="submitForm" @hook:mounted="doSomeThing">
            <template v-slot:upload>
                <el-form-item label="文章权限" prop="isRole" v-if='isShow'>
                    <el-radio v-model="operForm.isRole" label="0">开启</el-radio>
                    <el-radio v-model="operForm.isRole" label="1">关闭</el-radio>
                </el-form-item>
            </template>
        </my-dialog>

        <!-- 详情组件 -->
        <my-dialog-detail :isDialogDetailShow.sync="isDialogDetailShow" :operForm="operForm" :operFormArr="operFormArr" :closeDialog="closeDialog" />

        <!-- 充值组件 -->
        <my-recharge :isRechargeShow.sync="isRechargeShow" />

    </div>
</template>

<script>
import _exportMethods from "@/utils/excel";
import mixins from "@/mixins/common";
import {
    userList,
    addUser,
    editUser,
    delUser,
    allDelUser,
    updateUserRole,
    getUserRole,
} from "@/network/system/user";
import { roleDistribute } from "@/network/system/role";
export default {
    components: {
        /**
         * 异步组件(目前支持添加、编辑)
         * 不是一初始化就加载组件，而是当触发某种行为的时候才加载渲染组件并缓存，缓存是以备下次访问使用。
         */
        myRecharge: () => import("@/components/content/myRecharge"),
    },
    mixins: [mixins],
    provide() {
        return {
            importType: "user",
            initData: this.getInitData,
        };
    },
    watch: {
        tableData: {
            handler(val) {
                // console.log(val);
            },
            immediate: false,
            deep: false,
        },
    },
    data() {
        return {
            isShow: '',
            isRechargeShow: false,
            currentId: 0, //当前高亮行的用户id
            showButton: false,
            roleList: [], //角色列表
            checkRoleArr: [], //选中的角色
            /**
             * 当前头部数据列
             * 不需要响应式的数据可以进行冻结，Vue实例不会对数据再做数据劫持(getter、setter转换),可以提高Vue渲染性能
             * 不可以向当前对象添加、更新、删除属性。如需修改可以将变量的引用替换掉
             */
            tableHeader: Object.freeze([
                {
                    name: "用户姓名",
                    prop: "userZh",
                },
                {
                    name: "登录名",
                    prop: "username",
                },
                {
                    name: "手机号码",
                    prop: "tel",
                },
                {
                    name: "电子邮箱",
                    prop: "mail",
                },
                {
                    name: "企业管理员",
                    prop: "manage",
                    formatData(val) {
                        return ["否", "是"][
                            Number(val)
                        ];
                    },
                },
                {
                    name: "创建时间",
                    prop: "createTime",
                },
                {
                    name: "操作",
                    prop: "operation",
                    width: "200px",
                    operation: [
                        { name: "详情", clickFun: this.detailUser },
                        { name: "编辑", clickFun: this.editUser },
                        { name: "删除", clickFun: this.delUser },
                    ],
                },
            ]),
            //筛选时文本框所需参数
            inputArr: [
                {
                    name: "textUserZh",
                    defaultText: "请输入用户姓名",
                },
                {
                    name: "textUserName",
                    defaultText: "请输入登录名",
                },
                {
                    name: "textTel",
                    defaultText: "请输入手机号码",
                },
            ],
            //添加、编辑时文本框所需参数
            operFormArr: [
                {
                    name: "userZh",
                    label: "用户姓名",
                    defaultText: "请输入用户姓名",
                },
                {
                    name: "username",
                    label: "登录名",
                    defaultText: "请输入登录名",
                },
                {
                    name: "tel",
                    label: "手机号码",
                    defaultText: "请输入手机号码",
                },
                {
                    name: "mail",
                    label: "电子邮箱",
                    defaultText: "请输入电子邮箱",
                },
            ],
            // selectArr: Object.freeze([
            //     {
            //         //0审核，1正常，
            //         label: "文章权限",
            //         getData: "value",
            //         prop: "isRole",
            //         defaultOptions: [
            //             { label: "开启", value: "0" },  //  0是开始状态  1是关闭状态  
            //             { label: "关闭", value: "1" },
            //         ],
            //     },
            // ]),
            //添加、编辑双向绑定值
            operForm: {
                id: "",
                userZh: "",
                username: "",
                tel: "",
                mail: "",
                isRole: ""
            },
            //搜索参数
            searchParams: {
                timeOptions: "",
                textUserZh: "",
                textUserName: "",
                textTel: "",
            },
            // rules表单验证
            rules: {
                userZh: [
                    {
                        required: true,
                        message: "请输入用户姓名",
                        trigger: "blur",
                    },
                ],
                username: [
                    {
                        required: true,
                        message: "请输入登录名",
                        trigger: "blur",
                    },
                ],
                tel: [
                    {
                        required: true,
                        message: "请输入手机号码",
                        trigger: "blur",
                    },
                ],
                mail: [
                    {
                        required: true,
                        message: "请输入电子邮箱",
                        trigger: "blur",
                    },
                ],
                isRole: [
                    {
                        required: true,
                        message: "请选择文章权限",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    created() {
        this.getRoleList();
    },
    methods: {
        getInitData() {
            let timeOptions = this.searchParams.timeOptions; //日期参数
            let params = {
                data: {
                    userZh: this.searchParams.textUserZh,
                    username: this.searchParams.textUserName,
                    tel: this.searchParams.textTel,
                },
                startTime: timeOptions ? timeOptions[0] : "",
                endTime: timeOptions ? timeOptions[1] : "",
                current: this.pageParams.currentPage,
                size: this.pageParams.pageSize,
            };
            userList(params).then((e) => {
                this.loading = false;
                let { code, data, msg } = e.data;
                if (code == 200) {
                    this.tableData = data.records;
                    this.pageParams.total = data.total;
                }
            });
        },
        //角色分配列表
        getRoleList() {
            roleDistribute({}).then((e) => {
                let { code, data, msg } = e.data;
                if (code == 200) {
                    this.roleList = data;
                    for (let v of this.roleList) {
                        v.createTime = false;
                    }
                }
            });
        },
        //添加、编辑
        submitForm({ valid }) {
            if (valid) {
                //根据类型不同调用不同的操作接口
                let interType = this.operTitle ? addUser : editUser;
                interType(this.operForm).then((e) => {
                    let { code, data, msg } = e.data;
                    console.log(e);
                    if (code == 200) {
                        this.isDialogShow = false;
                        this.loading = false;
                        this.getInitData();
                        this.$message.success("操作成功");
                    } else {
                        this.$message.error(msg);
                    }
                });
            } else {
                return false;
            }
        },
        //搜索事件
        searchEvent() {
            this.pageParams.currentPage = 1;
            this.getInitData();
        },
        //添加事件
        addEvent() {
            this.isDialogShow = true;
            this.operTitle = true;
            this.operForm = {}; //防止多次添加有上次添加的残留数据
        },
        //充值
        recharge() {
            this.isRechargeShow = true;
        },
        //详情事件
        detailUser(item) {
            this.isDialogDetailShow = true;
            this.operForm = item;
        },
        //编辑事件
        editUser(item) {
            this.isShow = item.manage
            this.isDialogShow = true;
            this.operTitle = false;
            this.operForm = {
                id: item.id,
                userZh: item.userZh,
                username: item.username,
                tel: item.tel,
                mail: item.mail,
                isRole: item.isRole,
            };
        },
        //删除事件
        delUser(item) {
            this.$confirm("删除该条数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                delUser(item.id).then((e) => {
                    let { code, data, msg } = e.data;
                    if (code == 200) {
                        this.getInitData();
                        this.$message.success("操作成功");
                    } else {
                        this.$message.error("操作失败");
                    }
                });
            });
        },
        //批量删除
        allDel() {
            let data = this.selectedData;
            if (data.length == 0) {
                this.$message.warning("请选择要操作的数据！");
                return;
            }
            this.$confirm("删除所选数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                let delIds = [];
                delIds = data.map((e) => e.id);
                allDelUser({
                    ids: delIds,
                }).then((e) => {
                    let { code, data, msg } = e.data;
                    if (code == 200) {
                        this.getInitData();
                        this.$message.success("操作成功");
                    } else {
                        this.$message.error("操作失败");
                    }
                });
            });
        },
        // 保存角色
        saveRole() {
            if (this.checkRoleArr.length == 0) {
                this.$message.warning("请选择要分配的角色！");
                return;
            }
            let params = {
                userId: this.currentId,
                roleIds: this.checkRoleArr,
            };
            updateUserRole(params).then((e) => {
                let { code, data, msg } = e.data;
                if (code == 200) {
                    this.getInitData();
                    this.$message.success("操作成功");
                } else {
                    this.$message.error("操作失败");
                }
            });
        },
        //单击事件
        handleCurrentChange(val) {
            if (val) {
                this.currentId = val.id;
                this.showButton = true;
                getUserRole(val.id).then((e) => {
                    let { code, data, msg } = e.data;
                    if (code == 200) {
                        this.checkRoleArr = data;
                    }
                });
            }
        },
        //批量导出
        allExport() {
            let timeOptions = this.searchParams.timeOptions; //日期参数
            let data = {
                data: {
                    userZh: this.searchParams.textUserZh,
                    username: this.searchParams.textUserName,
                    tel: this.searchParams.textTel,
                },
                startTime: timeOptions ? timeOptions[0] : "",
                endTime: timeOptions ? timeOptions[1] : "",
                current: this.pageParams.currentPage,
                size: this.pageParams.pageSize,
            };
            let exportParams = {
                method: "post",
                url: "/api/app/sys/user/export/list",
                data,
            };
            _exportMethods(exportParams);
        },
        //导入模板
        allImportTemplate() {
            let importParams = {
                method: "get",
                url: "/api/app/sys/user/export/template",
            };
            _exportMethods(importParams);
        },
        //详情函数式组件关闭弹框
        closeDialog() {
            this.isDialogDetailShow = false;
        },
        //在子组件上监听点击事件，如果不加.native的话，Vue会以为是自定义的事件，这样的话必须得在子组件发送一个emit事件触发才可以
        testNative() {
            console.log("native click");
        },
        //在父组件里监听到子组件的生命周期 @hook:mounted="doSomething"
        doSomeThing() {
            // console.log('父组件监听到 mounted 钩子函数 ...');
        },
    },
};
</script>

<style lang="scss" scoped>
.role-span {
    font-weight: bold;
    color: #303133;
    font-size: 15px;
}
</style>


 
 